import React from 'react';

function CommitmentModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Dark background overlay */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-60"
        onClick={onClose}
      ></div>
      
      {/* Modal content */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl mx-4 p-8 transform transition-all">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Our Promise To You</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto rounded-full"></div>
        </div>
        
        {/* Content */}
        <div className="text-center space-y-6">
          
          <p className="text-xl leading-relaxed text-gray-700">
            AI-generated resumes, fake applications and cheating make it impossible for companies to spot real talent, forcing them to evaluate everyone.
          </p>
          
          <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-6 border border-blue-100">
            <p className="text-xl leading-relaxed text-gray-800 font-medium">
              Our promise: a lean, fair, and respectful process, designed to ensure every candidate gets genuine consideration.
            </p>
          </div>
        </div>
        
        {/* Footer */}
        <div className="text-center mt-8 text-xl">
          <button
            onClick={onClose}
            className="bg-gradient-to-r from-blue-500 to-green-500 text-white px-8 py-3 rounded-lg font-medium hover:from-blue-600 hover:to-green-600 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default CommitmentModal;
